import { render, staticRenderFns } from "./CreateVehicleDialog.vue?vue&type=template&id=b5b5237a&"
import script from "./CreateVehicleDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateVehicleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports